import React, { useEffect, useState, useMemo } from 'react'
import { useTranslate } from '../../components/TranslationText';
import { getAlbums } from './api/GalleryApi';
import NetaqInput from '../../components/NetaqInput';
import SearchBox from '../../components/SearchBox';
import Album from '../../components/Album';
import NewActionButton from '../../components/ActionButtons/NewActionButton';

export default function GalleryPage() {
    const albumsPerPage = 2;
    const { translate } = useTranslate();

    const [gallery, setGalleryItems] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [seasonList, setSeasonList] = useState([]);
    const [searchKeyWord, setSearchKeyWord] = useState("");
    const [selectedSeason, setSellectedSeason] = useState(null);
    const [visibleCount, setVisibleCount] = useState(albumsPerPage);

    useEffect(() => {
        setIsLoading(true);
        getAlbums().then(res => {
            setGalleryItems(res);
            const uniqueFormattedData = [...new Set(res.map(x => x.season))]
                .map(season => ({ label: season, value: season, text: season }));
            setSeasonList(uniqueFormattedData);
            setLoaded(true);
            setIsLoading(false);
        });
    }, []);

    // --- Filtering logic ---
    const filteredAlbums = useMemo(() => {
        return gallery.filter(item => {
            const matchSeason = selectedSeason ? item.season === selectedSeason.value : true;
            const matchSearch = searchKeyWord
                ? item.albumName.toLowerCase().includes(searchKeyWord.toLowerCase())
                : true;
            return matchSeason && matchSearch;
        });
    }, [gallery, selectedSeason, searchKeyWord]);

    // --- Visible albums (pagination) ---
    const visibleAlbums = filteredAlbums.slice(0, visibleCount);

    const handleLoadMore = () => {
        setVisibleCount(prev => prev + albumsPerPage);
    };

    return (
        <div className='row pt-3'>
            <h2 className='text-start fw-bold col-lg-6 col-md-6 col-sm-12 col-12 mb-main'>
                {translate('web.photoGallery', 'Photo Gallery')}
            </h2>
            <div className='col-lg-3 col-md-3 col-sm-12 mb-main'>
                <NetaqInput
                    type={'select'}
                    isClearable={true}
                    name={'season'}
                    placeholder={translate('web.season', 'Season')}
                    label={translate('web.season', 'Season')}
                    listSelect={seasonList}
                    value={selectedSeason}
                    hideLable={true}
                    onChange={(e) => setSellectedSeason(e)}
                />
            </div>
            <div className='col-lg-3 col-md-3 col-sm-12 mb-main'>
                <SearchBox
                    onSubmit={(e) => e.preventDefault()}
                    isFullWidth
                    onChange={(e) => setSearchKeyWord(e.target.value)}
                    placeholder={translate('web.search', 'Search').toUpperCase()}
                    isForm={true}
                    value={searchKeyWord}
                    key={'searchBox'}
                />
            </div>

            {loaded && visibleAlbums.map((item, index) => (
                <Album item={item} index={index} key={index} />
            ))}

            {/* Load More Button */}
            {visibleAlbums.length < filteredAlbums.length && (
                <div className="text-center mb-3">
                    <NewActionButton
                        classNames='btn w-unset btn-outline-success px-4 py-2 rounded'
                        onClick={handleLoadMore}
                        disabled={isLoading}
                        text={translate('web.loadMore', 'Load More')}
                    />
                </div>

            )}
        </div>
    )
}
